// extracted by mini-css-extract-plugin
export default {"category":"Category_category__1PZIw","category_container":"Category_category_container__ZKhPg","category_wrapper":"Category_category_wrapper__x6rye"};